import $ from 'jquery';

Drupal.behaviors.troaxSideMenuToggles = {
  attach() {
    $('.investor__side-nav.desktop')
      .once('troaxSideMenuToggles')
      .each((index, element) => this.menuBehavior(element));
  },

  menuBehavior() {
    const span = $('.investor__side-nav').find('span');
    const expanded = $('.investor__side-nav').find('.expanded');

    function _addEventListeners() {
      for (let i = 0; i < span.length; i++) {
        span[i].addEventListener('click', (e) => showHideChildren(e));
      }
    }

    function _initMenu() {
      expanded.each(function () {
        if (!$(this).hasClass('in_active_trail')) {
          _hideChildList($(this));
        } else {
          _showChildList($(this));
        }
      });

      _addEventListeners();
    }

    function _showChildList(node) {
      node.find('ul').removeClass('hidden');
      node.find('div').find('span').addClass('fa-chevron-up');
      node.find('div').find('span').removeClass('fa-chevron-down');
    }

    function _hideChildList(node) {
      node.find('ul').addClass('hidden');
      node.find('div').find('span').addClass('fa-chevron-down');
      node.find('div').find('span').removeClass('fa-chevron-up');
    }

    function showHideChildren(e) {
      e.preventDefault();
      let target = $(e.target).parent().parent().children()[1];
      if (target.classList.contains('hidden')) {
        target.classList.remove('hidden');
        e.target.classList.remove('fa-chevron-down');
        e.target.classList.add('fa-chevron-up');
      } else {
        target.classList.add('hidden');
        e.target.classList.remove('fa-chevron-up');
        e.target.classList.add('fa-chevron-down');
      }
    }
    _initMenu();
  },
};
